import domain from './domain';
import { resetClientOpenTaskListData } from './events';
import { OpenTaskListData } from 'dy-frontend-shared/lib/data/types';

// Open task list data
export const $clientOpenTaskListData = domain
    .createStore<OpenTaskListData | null>(null)
    .reset(resetClientOpenTaskListData);
